import React from 'react'

import './HeuristicScores.css'
import { HeuristicScore } from '@/api/types'
import ReadableStringUtils from '@/features/utils/ReadableStringUtils'

type Props = {
  heuristicScores: Array<HeuristicScore>
}

export function HeuristicScores({ heuristicScores }: Props) {
  const sorted = [...heuristicScores].sort((a, b) => b.value * b.weight - a.value * a.weight)

  return (
    <div className="heuristic-scores-grid">
      {sorted.map(({ name, value, weight }) => {
        const contribution = value * weight
        return (
          <div key={name} className="heuristic-score-card">
            <div className="header">{ReadableStringUtils.readableHeuristicName(name)}</div>

            <div className="contribution" style={{ color: getColor(contribution) }}>
              +{contribution.toFixed(2)}
            </div>

            <div className="bar-container">
              <div
                className="bar-fill"
                style={{
                  width: `${Math.min(100, contribution * 100)}%`,
                  backgroundColor: getColor(contribution),
                }}
              />
            </div>

            <div className="details">
              <span>val: {value.toFixed(2)}</span>
              <span>wt: {weight.toFixed(2)}</span>
            </div>
          </div>
        )
      })}
    </div>
  )
}

function getColor(contribution: number) {
  if (contribution < 0.33) return '#e74c3c'
  if (contribution < 0.66) return '#f39c12'
  return '#2ecc71'
}
